import { TTagsManager } from '../../types/tag';
import { getTermValue, resetTerms } from '../../../../JsonQuery';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'flatShare' as const;

export const flatShareTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const flatShare = getTermValue('flat_share')(jsonQuery);

    if (flatShare === null) {
      return null;
    }

    const label = flatShare === 1 ? 'Только доли' : 'Без долей';

    return [{ label, value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['flat_share'])(jsonQuery),
};
